<template>
    <div class="card mt-1">
        <div class="card-body">
            <div class="report-title p-2">Report</div>
            <div class=" d-flex justify-content-between align-items-center p-2">
                <div class="key-metrics">Key metrics</div>
                <DateRangePicker />
            </div>
            <div class="mt-4 p-2 mb-5">
                <div class=" d-flex justify-content-between">
                    <div class="report-left-text">Total face value</div>
                    <div class="report-right-text">Total commission</div>
                </div>
                <div class=" d-flex justify-content-between">
                    <div class="total-face-value mt-1">{{ formatCurrency(reportInfo.total_face_value) }}</div>
                    <div class="total-commission mt-1">{{ formatCurrency(reportInfo.total_commission) }}</div>
                </div>
                <div class="line-1"></div>
                <div class=" d-flex justify-content-between">
                    <div class="report-left-text">Transactions</div>
                    <div class="report-right-text">Total fees paid</div>
                </div>
                <div class=" d-flex justify-content-between">
                    <div class="transactions-value mt-1">{{ reportInfo.transaction_count }}</div>
                    <div class="total-fees-paid mt-1">{{ formatCurrency(reportInfo.total_fees_paid) }}</div>
                </div>
                <div class="line-1"></div>
                <div class="d-flex justify-content-between">
                   <div class="fees-text">Fees</div>
                   <div class="fees-value">{{ formatCurrency(reportInfo.summary.fees) }}</div>
                </div>
                <div class="d-flex justify-content-between">
                    <div class="fees-text">Refunds</div>
                    <div class="fees-value">{{ formatCurrency(reportInfo.summary.refunds) }}</div>
                </div>
                <div class="line-2"></div>
                <div class=" d-flex justify-content-between">
                    <div class="total-fees-text">Total fees & refunds</div>
                    <div class="total-fees-value">{{ formatCurrency(reportInfo.summary.fees + reportInfo.summary.refunds) }}</div>
                </div>
                <div class="line-3"></div>
                <div class=" d-flex justify-content-between">
                    <div class="amount-settled">Amount settled</div>
                    <div class="amount-settled-value">{{ formatCurrency(reportInfo.summary.amount_settled) }}</div>
                </div>
                <div class=" d-flex justify-content-between">
                    <div class="amount-balance">Account balance</div>
                    <div class="amount-balance-value">{{ formatCurrency(reportInfo.summary.amount_balance) }}</div>
                </div>
                <div class="amount-text">(Money in your account pending withdrawal)</div>
            </div>
        </div>
    </div>

    

</template>

<script setup>
import { onMounted,computed } from 'vue';
import DateRangePicker from './dateRangePicker.vue';
import { useReportStore } from '@/store/driver/report';

const reportStore = useReportStore();
const reportInfo = computed(() => reportStore.reportInfo);


const formatCurrency = (value) => {
  const absValue = Math.abs(value); // 取得絕對值並固定為兩位小數
  return value < 0 ? `-$${absValue}` : `$${absValue}`;
};


onMounted(()=>{
    reportStore.fetchReportInfo('this_month');
});
</script>

<style scoped>

.card {
    position: absolute;
    top: 80px;
    left: 0;
    right: 0;
    z-index: 1;
    height: 90%;
    width: 100%; /* 設置寬度為 100% */
    overflow-y: auto;
    overflow-x: hidden; /* 防止左右滑動 */
    border-radius: 10px 10px 0px 0px;
}

.report-title{
    width: 169px;
    height: 30px;
    /* Portal/Portal – H4 bold */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;
    margin-bottom: 25px;
    margin-top: 5px;

    /* 1E1E2D */
    color: #1E1E2D;
}

.key-metrics{
    /* Portal/Portal – H5 */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 25px;

    /* 1E1E2D */
    color: #1E1E2D;
}

.report-left-text{
    /* Total face value */
    width: 153px;
    height: 20px;

    /* Portal/Portal – H7 */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;

    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;

}

.report-right-text{
    /* Total commission */
    width: 153px;
    height: 20px;

    /* Portal/Portal – H7 */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;

    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
}

.total-face-value{
    width: 153px;
    height: 28px;

    /* Portal/Portal – H3 regular */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 400;
    font-size: 30px;
    line-height: 38px;
    display: flex;
    align-items: center;

    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 1;
    align-self: stretch;
    flex-grow: 0;
}

.total-commission{
    /* $1,957.61 */

    width: 153px;
    height: 28px;

    /* Portal/Portal – H3 bold */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 600;
    font-size: 30px;
    line-height: 38px;
    display: flex;
    align-items: center;

    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 1;
    align-self: stretch;
    flex-grow: 0;
}

.transactions-value{
    width: 160px;
    height: 28px;

    /* Portal/Portal – H4 */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 30px;
    display: flex;
    align-items: center;

    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 1;
    align-self: stretch;
    flex-grow: 0;
}

.total-fees-paid{
    width: 153px;
    height: 28px;

    /* Portal/Portal – H4 */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 30px;
    display: flex;

    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 1;
    align-self: stretch;
    flex-grow: 0;
}

.fees-text{
    width: 155px;
    height: 38px;

    /* Portal/Portal – body small */
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 19px;
    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 1;
}

.fees-value{
    /* Portal/Portal – H7 */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    align-items: center;
    text-align: right;

    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 2;
    flex-grow: 1;
}

.total-fees-text{
    width: 187.5px;
    height: 50px;

    /* Portal/Portal – H6 */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 23px;
    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;

}

.total-fees-value{
    width: 97.5px;
    height: 50px;

    /* Portal/Portal – H5 */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 25px;
    text-align: right;

    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 1;
    flex-grow: 1;
}

.amount-settled{
    width: 155px;
    height: 38px;

    /* Portal/Portal – H6 */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 23px;

    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 1;

}

.amount-settled-value{
    width: 155px;
    height: 38px;

    /* Portal/Portal – H5 */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 25px;
    text-align: right;

    /* Green */
    color: #00C962;


    /* Inside auto layout */
    flex: none;
    order: 2;
    flex-grow: 1;
}

.amount-balance{
    width: 177px;

    /* Portal/Portal – body small */
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 19px;
    /* identical to box height */

    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;

}

.amount-balance-value{
    width: 133px;

    /* Portal/Portal – H6 */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 23px;
    text-align: right;
    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 2;
    align-self: stretch;
    flex-grow: 0;

}

.amount-text{
    width: 177px;
    height: 36px;

    /* Portal/Portal – body extra small */
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;

    /* Dark grey */
    color: #5E707D;


    /* Inside auto layout */
    flex: none;
    order: 1;
    flex-grow: 0;
}

.line-1{
    margin-top: 20px;
    margin-bottom: 20px;
    /* Grey */
    border: 1px solid #99A6B4;

    /* Inside auto layout */
    flex: none;
    order: 1;
    align-self: stretch;
    flex-grow: 0;
}

.line-2{
    margin-top: 0px;
    margin-bottom: 20px;
    /* Grey 25% */
    border: 1px solid #E6E9EC;

    /* Inside auto layout */
    flex: none;
    order: 2;
    align-self: stretch;
    flex-grow: 0;
}

.line-3{
    margin-top: 10px;
    margin-bottom: 30px;
    /* Grey */
    border: 1px solid #99A6B4;

    /* Inside auto layout */
    flex: none;
    order: 5;
    align-self: stretch;
    flex-grow: 0;

}

</style>

